import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import AgConvergeReportImg from '../images/Spurimage.png';
import FTACReportImg from '../images/FarmerTechAdoptionChallenge.jpg';
import AgConvergeReportPDF from '../assets/AgConverge_25_Report.pdf';

import HhdBoothImg from '../images/hhd-2026-booth-signup.jpg';
import HhdFarmerImg from '../images/hhd-2026-farmer-conversation.jpg';
import HhdBannerImg from '../images/hhd-2026-spur-banner-row.jpg';
import HhdKairoImg from '../images/hhd-2026-kairospace-booth.jpg';
import '../styles/FeaturedPress.css';

const Resources = () => {
  const [activeTab, setActiveTab] = useState('reports');
  const [activeMediaIndex, setActiveMediaIndex] = useState(0);
  const [openStoryId, setOpenStoryId] = useState(null);

  /* =========================================================
     REPORTS
     ========================================================= */

  const reports = [
    {
      badge: '2025 CONFERENCE REPORT',
      title:
        "Spur AgConverge '25 Report — Where Innovation Meets the Farms",
      description:
        'Download our official report from the inaugural Spur AgConverge conference held on Nov 24, 2025 in Gothenburg, NE. The report covers the keynote from grower and industry experts, startup pitches, the Farm Tech Adoption Challenge, the Industry-Academia Panel, and live AgTech demos.',
      date: 'November 2025',
      downloadUrl: AgConvergeReportPDF,
      image: AgConvergeReportImg,
      imageColor: '#1a3a0a',
    },
    {
      badge: 'CONFERENCE REPORT',
      title: 'Farm Tech Adoption Challenge Report',
      description:
        'The Farm Tech Adoption Challenge positioned farmers as active evaluators of AgTech startups — not passive recipients. Across five roundtables at Spur AgConverge 2025, 14 farmers evaluated nine startups using structured Challenge, Barrier, Decision, and Commitment cards. Five startups secured farmer commitment and three received conditional interest.',
      date: 'November 2025',
      downloadUrl:
        'https://digitalcommons.unl.edu/biosysengpres/88/',
      image: FTACReportImg,
      imageColor: '#2D5016',
    },
  ];

  /* =========================================================
     RESEARCH & PUBLICATIONS
     ========================================================= */

  const publications = [
    {
      badge: 'WHITE PAPER',
      badgeIcon: '📄',

      title: 'Nebraska AgTech Innovation Report',

      authors:
        'Ankit Chandra, Ishani Lal, and Brennan Costello',

      journal:
        'Nebraska and the Midwest AgTech Ecosystem: Benchmarking Innovation Investment and Translation Gaps — Spur Ventures Research',

      date: 'July 2026',

      description:
        'A diagnostic analysis of Nebraska and the Midwest AgTech ecosystem examining venture capital investment, innovation translation efficiency, commercialization gaps, ecosystem coordination, and opportunities for translating Nebraska’s agricultural leadership into innovation leadership.',

      route:
        '/resources/nebraska-agtech-innovation-report',

      downloadUrl: '#',
    },

    {
      badge: 'PEER-REVIEWED',
      badgeIcon: '🔬',

      title:
        'Nebraska AgTech Innovation Ecosystem Map 2026',

      authors:
        'Chandra, A. and Costello, B.',

      journal:
        'Nebraska AgTech Innovation Ecosystem Map 2026. Spur Ventures',

      date: 'April 2026',

      description:
        'The 2026 Nebraska AgTech innovation ecosystem map, developed by Spur Ventures and The Combine, highlights the evolving agricultural technology entrepreneurial and business landscape across the state.',

      route:
        '/resources/nebraska-agtech-map-2026',

      downloadUrl: '#',
    },

    {
      badge: 'PEER-REVIEWED',
      badgeIcon: '🔬',

      title:
        'Why AgTech Startups Fail? Evidence from Global Shutdown Patterns in 2025 and the Cost-Adoption Mismatch Effect',

      authors:
        'Chandra, A. and Lal, I.',

      journal:
        'Open access (CC BY-NC 4.0). Department of Biological Systems Engineering, University of Nebraska-Lincoln.',

      date: 'January 2026',

      description:
        'The paper presents an analysis of 18 publicly reported AgTech startup shutdowns in 2025 across sectors and finds that failure was driven less by scientific feasibility and more by a Cost-Adoption Mismatch Effect.',

      route:
        '/resources/why-agtech-startups-fail',

      downloadUrl: '#',
    },
  ];

  /* =========================================================
     MEDIA COVERAGE
     ========================================================= */

  const mediaCoverage = [
    {
      id: 'husker-harvest-days-2026',
      outlet: 'Spur Ventures',
      badge: 'News',
      date: 'September 18, 2026',
      title:
        'Global AgTech Startups Bring Innovation to Nebraska Growers at Husker Harvest Days',
      description:
        'Three international startups in the Spur Startup Sandbox Validation Program, EF Polymer, Kairospace Technologies and BharatRohan, showcased their technologies, built commercial relationships and engaged directly with Nebraska farmers at the 2026 Husker Harvest Days near Grand Island.',
      linkLabel: 'Read Full Story',
      story: [
        { t: 'img', src: HhdBoothImg, alt: 'A visitor fills out a form at a startup booth at Husker Harvest Days', cap: 'A visitor stops to fill out a form at one of the startup booths at Husker Harvest Days.' },
        { t: 'p', x: 'GRAND ISLAND, Neb. — Three international agricultural technology startups participating in the University of Nebraska-Lincoln’s Spur Ventures Startup Sandbox Validation Program brought their technologies directly to Nebraska farmers, industry leaders and potential commercial partners during the 2026 Husker Harvest Days, held Sept. 15–17 near Grand Island.' },
        { t: 'p', x: 'EF Polymer, Kairospace Technologies and BharatRohan exhibited and demonstrated their technologies as part of the University of Nebraska’s SmartAcre Ag Technology Innovation Plots, giving the startups an opportunity to move beyond laboratory and research settings to engage directly with the agricultural community.' },
        { t: 'p', x: 'The three startups are part of Spur Ventures’ Startup Sandbox Validation Program, which connects agtech companies with Nebraska’s research infrastructure, growers, technical expertise and agricultural ecosystem to help validate technologies for real-world applications and accelerate commercialization. Husker Harvest Days provided the next critical piece of that process: direct access to farmers and industry.' },
        { t: 'p', x: '“For us, the real value of Husker Harvest Days was seeing validation and commercialization happen side by side,” said Ankit Chandra, Founder and Director of Spur Ventures at the University of Nebraska-Lincoln. “Our startups demonstrated their technologies, listened directly to farmers and built relationships that will continue well beyond the show. In some cases, those conversations moved directly toward commercial transactions — that is what we want the Startup Sandbox to enable: helping promising technologies move from ‘Does this work?’ to ‘How do we get this into farmers’ hands?’”' },
        { t: 'h', x: 'From international innovation to Nebraska farms' },
        { t: 'h3', x: 'EF Polymer' },
        { t: 'p', x: 'EF Polymer, a Japan-headquartered startup, showcased its biodegradable super-absorbent polymer technology designed to improve water and nutrient retention in the crop root zone. During the event, the company engaged directly with Nebraska producers and converted several farmer conversations into product sales — an early example of how international agtech companies can use Nebraska as a pathway into the U.S. agricultural market.' },
        { t: 'img', src: HhdFarmerImg, alt: 'A producer listens as a startup representative points to a handout beside a table of EF Polymer product bags', cap: 'A producer and startup team members talk at the EF Polymer booth.' },
        { t: 'quote', x: '“What stood out at Husker Harvest Days was the caliber of people we met — growers, distributors, retailers — who understood exactly what our polymer technology solves. We left with real partnership conversations already in motion, not just interest.”', by: 'Kenny Toyonaga', role: 'Head of U.S. Business, EF Polymer' },
        { t: 'h3', x: 'Kairospace Technologies' },
        { t: 'p', x: 'Kairospace Technologies demonstrated its nanobubble-based technology, highlighting potential applications related to water and oxygen availability, soil health and crop production.' },
        { t: 'quote', x: '“Husker Harvest Days let us put our nanobubble technology in front of the farmers and industry leaders who will actually decide whether to use it. The Spur program gave us the access and support to make those conversations happen, and they’ll directly shape how we approach the U.S. market.”', by: 'Juan Bravin', role: 'CEO, Kairospace Technologies' },
        { t: 'img', src: HhdKairoImg, alt: 'The Kairospace Technologies booth under a red tent with two tall banners', cap: 'The Kairospace Technologies booth.', tall: true },
        { t: 'h3', x: 'BharatRohan' },
        { t: 'p', x: 'BharatRohan showcased its hyperspectral drone imaging and analytics technology, which uses aerial data to help identify crop stress and support more informed agronomic decision-making.' },
        { t: 'p', x: 'Across all three, the format gave founders a chance to demonstrate their technologies in a working agricultural environment while meeting growers who could speak directly to practical farm needs, economics, implementation and potential adoption.' },
        { t: 'h', x: 'Building partnerships beyond the show' },
        { t: 'p', x: 'The three-day event also connected founders with agricultural companies, researchers, distributors and other organizations working to bring new technologies to market.' },
        { t: 'p', x: '“What stood out was the quality of the conversations,” said Chandra. “They went beyond technology — distribution, field validation, farmer adoption, commercialization. Those are the relationships that determine whether a technology moves from a promising startup to a solution farmers actually use.”' },
        { t: 'quote', x: '“Nebraska can be a launchpad for global agtech. We have farmers willing to test new ideas, researchers who understand agricultural systems and industry partners who understand commercialization. Our role at Spur is to connect those pieces and help entrepreneurs move from technology development to market adoption.”', by: 'Ankit Chandra', role: 'Founder and Director, Spur Ventures', feature: true },
        { t: 'h', x: 'A new model for connecting global startups with U.S. agriculture' },
        { t: 'p', x: 'The program extends Spur’s mission by giving international entrepreneurs a chance to work within Nebraska’s agricultural ecosystem — while giving Nebraska growers and companies a chance to engage with technologies from around the world.' },
        { t: 'img', src: HhdBannerImg, alt: 'A row of red tents beside a center pivot with a tall Let’s Spur Innovation banner in the foreground', cap: 'Startup booths lined up along the exhibit row, with the Spur Ventures banner in the foreground.' },
        { t: 'p', x: 'Husker Harvest Days showed how that model can extend beyond research trials. “Our goal is not simply to bring startups to Nebraska,” Chandra said. “It is to help them build roots here — with farmers, researchers, companies and potential customers. The next step for these companies is turning this week’s relationships and feedback into field trials, partnerships and commercial opportunities.”' },
        { t: 'about', x: 'Spur Ventures at the University of Nebraska–Lincoln is Nebraska’s translational agtech innovation and venture lab, connecting students, researchers, startups, growers and industry partners to accelerate agricultural technologies from discovery to field adoption and market. The Startup Sandbox Validation Program connects global agtech startups with Nebraska’s agricultural research infrastructure, growers, technical expertise and industry ecosystem to validate technologies for real-world applications and accelerate commercialization.' },
      ],
    },
    {
      id: 'agtech-success-midwest',

      outlet: 'AgNavigator',

      badge: 'Research Coverage',

      date: 'August 4, 2026',

      title:
        'Agtech Success Is Built, Not Inherited, Says Midwest Innovation Study',

      description:
        'New research from the University of Nebraska–Lincoln finds that agricultural strength alone does not guarantee AgTech startup growth or investment. The Midwest study highlights the importance of deliberately building capital, commercialization infrastructure, startup pipelines, and stronger connections among researchers, entrepreneurs, investors, industry, and farmers.',

      url:
        'https://www.agnavigator.com/Article/2026/08/04/agtech-success-is-built-not-inherited-says-midwest-innovation-study/',

      linkLabel: 'Read Full Story',
    },
    {
      id: 'startup-sandbox',
      outlet: 'Silicon Prairie News',
      badge: 'Feature',
      date: 'June 30, 2026',

      title:
        'Global AgTech Startups Choose Nebraska in New Spur Startup Sandbox Validation Program',

      description:
        'Four international startups will work with University of Nebraska–Lincoln researchers, industry partners, and local farmers to test and validate agricultural technologies through the Spur Startup Sandbox Validation Program.',

      url:
        'https://siliconprairienews.com/2026/06/global-agtech-startups-choose-nebraska-in-new-spur-startup-sandbox-validation-program/',

      linkLabel: 'Read Full Story',
    },

    {
      id: 'agtech-map',
      outlet: 'Silicon Prairie News',
      badge: 'Ecosystem',
      date: 'May 26, 2026',

      title:
        'New AgTech Innovation Map Shows Nebraska’s Startup Ecosystem Getting Stronger Despite Few Exits',

      description:
        'The Nebraska AgTech Innovation Map highlights the state’s growing network of AgTech startups, founders, researchers, support organizations, and commercialization resources.',

      url:
        'https://siliconprairienews.com/2026/05/new-agtech-innovation-map-shows-nebraskas-startup-ecosystem-getting-stronger-despite-few-exits/',

      linkLabel: 'Read Full Story',
    },

    {
      id: 'startup-playbook',
      outlet: 'AgTech Navigator',
      badge: 'Analysis',
      date: 'January 28, 2026',

      title:
        'Why AgTech Start-Ups Failed Last Year — and a Playbook for 2026',

      description:
        'An analysis of commercial, financial, and market-alignment challenges affecting AgTech startups, along with lessons for founders building stronger companies.',

      url:
        'https://www.agtechnavigator.com/Article/2026/01/28/why-agtech-start-ups-failed-last-year-and-a-playbook-for-2026/',

      linkLabel: 'Read Full Story',
    },

    {
      id: 'business-models',
      outlet: 'Farming Future Food',
      badge: 'Article',
      date: '2026',

      title:
        'Misaligned Business Models, Not Technology, Behind Recent AgTech Shutdowns',

      description:
        'A closer look at why promising agricultural technologies can struggle when pricing, customer needs, and business models are not properly aligned.',

      url:
        'https://farmingfuturefood.com/misaligned-business-models-not-technology-behind-recent-ag-tech-shutdowns/',

      linkLabel: 'Read Full Story',
    },

    {
      id: 'nebraska-tv',
      outlet: 'Nebraska TV',
      badge: 'TV Report',
      date: '2025',

      title:
        'Ag Industry Gathers in Gothenburg for Innovative Startup Program Launch',

      description:
        'Nebraska TV highlighted the launch of Spur AgConverge and its work connecting farmers, startups, researchers, students, and agricultural industry leaders.',

      url:
        'https://nebraska.tv/news/local/ag-industry-gathers-in-gothenburg-for-innovative-startup-program-launch',

      linkLabel: 'Watch Report',
    },

    {
      id: 'farm-adoption',
      outlet: 'Silicon Prairie News',
      badge: 'Feature',
      date: 'December 2025',

      title:
        'With Tough Times for Farms, AgTech Adoption Is No Easy Task — But Startups and Farmers See Potential',

      description:
        'Coverage of the inaugural Spur AgConverge conference and its farmer-led approach to evaluating agricultural technologies, adoption barriers, and startup opportunities.',

      url:
        'https://siliconprairienews.com/2025/12/with-tough-times-for-farms-agtech-adoption-is-no-easy-task-but-at-a-new-unl-conference-in-gothenburg-startups-and-farmers-see-potential/',

      linkLabel: 'Read Full Story',
    },
  ];

  const activeMediaArticle =
    mediaCoverage[activeMediaIndex];

  /* =========================================================
     MEDIA KEYBOARD NAVIGATION
     ========================================================= */

  const handleMediaKeyDown = (event, index) => {
    let nextIndex = index;

    if (
      event.key === 'ArrowRight' ||
      event.key === 'ArrowDown'
    ) {
      nextIndex =
        (index + 1) % mediaCoverage.length;
    } else if (
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowUp'
    ) {
      nextIndex =
        (index - 1 + mediaCoverage.length) %
        mediaCoverage.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = mediaCoverage.length - 1;
    } else {
      return;
    }

    event.preventDefault();

    setActiveMediaIndex(nextIndex);

    window.requestAnimationFrame(() => {
      const nextTab = document.getElementById(
        `resources-media-tab-${mediaCoverage[nextIndex].id}`
      );

      nextTab?.focus();
    });
  };

  return (
    <div className="resources-page">

      {/* =====================================================
          HERO
          ===================================================== */}

      <section className="resources-hero">

        <div className="resources-hero-bg-circle resources-hero-bg-circle--left" />

        <div className="resources-hero-bg-circle resources-hero-bg-circle--right" />

        <div className="resources-hero-content">

          <h1 className="resources-hero-title">
            Spur Ventures Research
          </h1>

          <p className="resources-hero-subtitle">
            Reports, research publications, and media
            coverage from the frontier of AgTech innovation
            in Nebraska.
          </p>

        </div>
      </section>

      {/* =====================================================
          MAIN TABS
          ===================================================== */}

      <div className="resources-tab-bar">

        <div className="resources-tab-bar-inner">

          {/* Reports */}

          <button
            type="button"
            className={`resources-tab ${activeTab === 'reports'
              ? 'resources-tab--active'
              : ''
              }`}
            onClick={() => setActiveTab('reports')}
          >
            Reports

            <span className="resources-tab-count">
              {reports.length}
            </span>
          </button>

          {/* Research & Publications */}

          <button
            type="button"
            className={`resources-tab ${activeTab === 'publications'
              ? 'resources-tab--active'
              : ''
              }`}
            onClick={() =>
              setActiveTab('publications')
            }
          >
            Research &amp; Publications

            <span className="resources-tab-count">
              {publications.length}
            </span>
          </button>

          {/* Media */}

          <button
            type="button"
            className={`resources-tab ${activeTab === 'media'
              ? 'resources-tab--active'
              : ''
              }`}
            onClick={() => setActiveTab('media')}
          >
            Media Coverage

            <span className="resources-tab-count">
              {mediaCoverage.length}
            </span>
          </button>

        </div>
      </div>

      {/* =====================================================
          PAGE CONTENT
          ===================================================== */}

      <div className="resources-content">

        <div className="container">

          {/* =================================================
              REPORTS TAB
              ================================================= */}

          {activeTab === 'reports' && (
            <div className="resources-section">

              <div className="resources-section-header">

                <h2 className="resources-section-title">
                  Conference &amp; Program Reports
                </h2>

                <p className="resources-section-subtitle">
                  Official reports from Spur Ventures events
                  and programs — documenting findings,
                  outcomes, and insights.
                </p>

              </div>

              <div className="resources-cards">

                {reports.map((report, index) => (

                  <div
                    className="resources-card"
                    key={`${report.title}-${index}`}
                  >

                    {/* Report image */}

                    <div
                      className="resources-card-image"
                      style={
                        report.image
                          ? {}
                          : {
                            background:
                              `linear-gradient(135deg, ${report.imageColor} 0%, #4a7c59 100%)`,
                          }
                      }
                    >

                      {report.image ? (
                        <>
                          <img
                            src={report.image}
                            alt={report.title}
                            className="resources-card-photo"
                          />

                          <span className="resources-card-badge resources-card-badge--overlay">
                            {report.badge}
                          </span>
                        </>
                      ) : (
                        <>
                          <span className="resources-card-badge">
                            {report.badge}
                          </span>

                          <div className="resources-card-image-icon">
                            📊
                          </div>
                        </>
                      )}

                    </div>

                    {/* Report information */}

                    <div className="resources-card-body">

                      <span className="resources-card-date">
                        {report.date}
                      </span>

                      <h3 className="resources-card-title">
                        {report.title}
                      </h3>

                      <p className="resources-card-desc">
                        {report.description}
                      </p>

                      <a
                        href={report.downloadUrl}
                        className="resources-card-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                        download={
                          report.downloadUrl !== '#'
                        }
                      >
                        {report.downloadUrl === '#'
                          ? 'Coming Soon'
                          : 'View Report ↗'}
                      </a>

                    </div>

                  </div>
                ))}

              </div>

            </div>
          )}

          {/* =================================================
              RESEARCH & PUBLICATIONS TAB
              ================================================= */}

          {activeTab === 'publications' && (
            <div className="resources-section">

              <div className="resources-section-header">

                <h2 className="resources-section-title">
                  Research &amp; Publications
                </h2>

                <p className="resources-section-subtitle">
                  Peer-reviewed papers, conference
                  proceedings, white papers, and research
                  produced by The Spur&apos;s research team and
                  affiliated faculty.
                </p>

              </div>

              <div className="resources-pub-list">

                {publications.map(
                  (publication, index) => (

                    <div
                      className="resources-pub-item"
                      key={`${publication.title}-${index}`}
                    >

                      {/* Left metadata */}

                      <div className="resources-pub-left">

                        <span className="resources-pub-badge">
                          {publication.badgeIcon}{' '}
                          {publication.badge}
                        </span>

                        <span className="resources-pub-date">
                          {publication.date}
                        </span>

                      </div>

                      {/* Main publication content */}

                      <div className="resources-pub-body">

                        <h3 className="resources-pub-title">
                          {publication.title}
                        </h3>

                        <p className="resources-pub-meta">
                          {publication.authors}
                          {' — '}
                          <em>
                            {publication.journal}
                          </em>
                        </p>

                        <p className="resources-pub-desc">
                          {publication.description}
                        </p>

                        {/* Internal article page if route exists */}

                        {publication.route ? (

                          <Link
                            to={publication.route}
                            className="resources-pub-link"
                          >
                            View Article →
                          </Link>

                        ) : (

                          <a
                            href={
                              publication.downloadUrl
                            }
                            className="resources-pub-link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Article →
                          </a>

                        )}

                      </div>

                    </div>

                  )
                )}

              </div>

            </div>
          )}

          {/* =================================================
              MEDIA COVERAGE TAB
              ================================================= */}

          {activeTab === 'media' && (
            <div className="resources-section">

              <div className="resources-section-header">

                <h2 className="resources-section-title">
                  Media Coverage
                </h2>

                <p className="resources-section-subtitle">
                  News articles, features, and press
                  coverage highlighting The Spur
                  Ventures&apos; impact across Nebraska and
                  the AgTech industry.
                </p>

              </div>

              <div className="spur-press-tabs resources-spur-press-tabs">

                {/* Media tabs */}

                <div
                  className="spur-press-tab-list"
                  role="tablist"
                  aria-label="Spur Ventures media coverage"
                >

                  {mediaCoverage.map(
                    (article, index) => {

                      const isActive =
                        activeMediaIndex === index;

                      return (

                        <button
                          type="button"
                          role="tab"
                          id={`resources-media-tab-${article.id}`}
                          aria-controls={`resources-media-panel-${article.id}`}
                          aria-selected={isActive}
                          tabIndex={
                            isActive ? 0 : -1
                          }
                          className={`spur-press-tab ${isActive
                            ? 'spur-press-tab-active'
                            : ''
                            }`}
                          onClick={() =>
                            setActiveMediaIndex(index)
                          }
                          onKeyDown={(event) =>
                            handleMediaKeyDown(
                              event,
                              index
                            )
                          }
                          key={article.id}
                        >

                          <span className="spur-press-tab-number">
                            {String(
                              index + 1
                            ).padStart(2, '0')}
                          </span>

                          <span className="spur-press-tab-outlet">
                            {article.outlet}
                          </span>

                          <strong className="spur-press-tab-title">
                            {article.title}
                          </strong>

                          <span className="spur-press-tab-date">
                            {article.date}
                          </span>

                        </button>

                      );
                    }
                  )}

                </div>

                {/* Active media article */}

                <article
                  className="spur-press-panel"
                  role="tabpanel"
                  id={`resources-media-panel-${activeMediaArticle.id}`}
                  aria-labelledby={`resources-media-tab-${activeMediaArticle.id}`}
                  key={activeMediaArticle.id}
                >

                  <span
                    className="spur-press-panel-number"
                    aria-hidden="true"
                  >
                    {String(
                      activeMediaIndex + 1
                    ).padStart(2, '0')}
                  </span>

                  <div className="spur-press-panel-top">

                    <span className="spur-press-panel-type">
                      {activeMediaArticle.badge}
                    </span>

                    <span className="spur-press-panel-date">
                      {activeMediaArticle.date}
                    </span>

                  </div>

                  <div className="spur-press-panel-body">

                    <span className="spur-press-panel-outlet">
                      <i className="far fa-newspaper" />
                      {activeMediaArticle.outlet}
                    </span>

                    <h4>
                      {activeMediaArticle.title}
                    </h4>

                    <p>
                      {
                        activeMediaArticle.description
                      }
                    </p>

                    {activeMediaArticle.story &&
                      openStoryId === activeMediaArticle.id && (
                      <div className="spur-story" id={`story-${activeMediaArticle.id}`}>
                        {activeMediaArticle.story.map((b, i) => {
                          if (b.t === 'p') return <p key={i}>{b.x}</p>;
                          if (b.t === 'h') return <h5 key={i}>{b.x}</h5>;
                          if (b.t === 'h3') return <h6 key={i}>{b.x}</h6>;
                          if (b.t === 'about') return (
                            <div key={i} className="spur-story-about">
                              <strong>About Spur Ventures</strong>
                              <p>{b.x}</p>
                            </div>
                          );
                          if (b.t === 'quote') return (
                            <blockquote key={i} className={`spur-story-quote${b.feature ? ' is-feature' : ''}`}>
                              <p>{b.x}</p>
                              <footer><strong>{b.by}</strong> {b.role}</footer>
                            </blockquote>
                          );
                          return (
                            <figure key={i} className={`spur-story-fig${b.tall ? ' is-tall' : ''}`}>
                              <img src={b.src} alt={b.alt} loading="lazy" />
                              <figcaption>{b.cap}</figcaption>
                            </figure>
                          );
                        })}
                      </div>
                    )}

                  </div>

                  <div className="spur-press-panel-footer">

                    {activeMediaArticle.story ? (
                      <button
                        type="button"
                        className="spur-press-panel-link spur-story-toggle"
                        aria-expanded={openStoryId === activeMediaArticle.id}
                        aria-controls={`story-${activeMediaArticle.id}`}
                        onClick={() =>
                          setOpenStoryId(
                            openStoryId === activeMediaArticle.id
                              ? null
                              : activeMediaArticle.id
                          )
                        }
                      >
                        {openStoryId === activeMediaArticle.id
                          ? 'Close Story'
                          : activeMediaArticle.linkLabel}

                        <i
                          className={`fas ${
                            openStoryId === activeMediaArticle.id
                              ? 'fa-chevron-up'
                              : 'fa-chevron-down'
                          }`}
                        />
                      </button>
                    ) : (
                      <a
                        href={activeMediaArticle.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="spur-press-panel-link"
                      >
                        {activeMediaArticle.linkLabel}

                        <i className="fas fa-external-link-alt" />
                      </a>
                    )}

                    <span className="spur-press-panel-count">

                      {String(
                        activeMediaIndex + 1
                      ).padStart(2, '0')}

                      <span>/</span>

                      {String(
                        mediaCoverage.length
                      ).padStart(2, '0')}

                    </span>

                  </div>

                </article>

              </div>

            </div>
          )}

        </div>
      </div>

    </div>
  );
};

export default Resources;